import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager"
import { clientQuery } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";

const INIT_STATE = {
    loading: false,
    caseDetail: null,
    updateCoach: false
}

export const route = "modules/driverPerformance/views/caseDetail/redux/slice";

export const getCaseDetail = createAsyncThunk(
    "driverPerformance/caseDetail/getCaseDetail",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const { caseId } = payload;
            const response = await clientQuery(
                `
                query ($id: String!) {
                    data: getDriverPerformanceCase (id: $id) {
                        id           
                        caseNumber
                        driverId
                        driver {
                            id
                            name
                            tagIds
                        }
                        coachId
                        coach {
                            id
                            firstName
                            lastName
                        }
                        evaluateValues
                        categoryId
                        statusId
                        status {
                            entityId
                            label
                            nextStep
                            nextStatusId
                        }
                        rowIds
                        completedDate
                        startEvaluationDate
                        evaluateValues
                        notes
                        improvementOmit
                        targetAvgEvents
                        targetAvgEventsSuccess
                        targetRiskScore
                        targetRiskScoreSuccess
                        targetEvents
                        targetEventsSuccess
                        targetDistance
                        targetDistanceSuccess
                        createdOn
                        createdBy
                    }
                }
                `,
                {
                    id: `${caseId}`
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data ? { ...response.data, updateCoach: payload?.updateCoach || false } : null;
        } catch (exc) {
            ExceptionManager(exc, route, "getCaseDetail");
            return rejectWithValue(exc);
        }
    }
);

const driverPerformanceCaseDetailRedux = createSlice({
    name: route,
    initialState: INIT_STATE,
    reducers: {
        reset: (state, action) => {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        }
    },
    extraReducers: (builder) => {
        //getCaseDetail
        builder.addCase(getCaseDetail.pending, (state, action) => {
            state.loading = true;
            state.updateCoach = action.payload?.updateCoach || false;
        })
        builder.addCase(getCaseDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.caseDetail = action.payload;
        })
        builder.addCase(getCaseDetail.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceCaseDetailRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
